import { STRAPI } from "../loaders/global";
import Base from "./Base";

class File extends Base {
  constructor(data) {
    super();
    if (data) this._patch(data);
  }
  _patch(data) {
    let d = data.attributes;
    this.id = data.id ?? null;
    this.name = d.name ?? "";
    this.ext = d.ext ?? "";
    this._url = d.url ?? "";
  }

  get url() {
    return STRAPI + this._url;
  }
}

export default File;
